export enum OutpatientBenefits {
    PHYSICIAN_VISIT = "Physician visit",
    TELEMEDICINE_VISIT = "Telemedicine visit",
    THERAPY_SERVICES = "Therapy services",
    CHIROPRACTIC_CARE = "Chiropractic care",
    DURABLE_MEDICAL_EQUIPMENT = "Durable medical equipment"
}